import { render } from "./NavBar.vue?vue&type=template&id=e5868ff6"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__